import styled from 'styled-components';

import { ReactComponent as starSVG } from './images/star.svg';
import { ReactComponent as borderScratchSVG } from './images/border-scratch.svg';
import { CommonPluginContainer } from './CommonPluginContainer';

interface BackgroundProps {
  color: string;
}

interface StarsProps {
  color: string;
}

export const ScratchContainer = styled(CommonPluginContainer)`
  position: relative;
  width: 100%;
  margin-top: 18vh;
  padding: 0 7vw;
  box-sizing: border-box;
  filter: drop-shadow( 0 0.8vh 0.6vh rgba(0,0,0,.2));
`;
ScratchContainer.displayName = 'ScratchContainer';

export const ScratchBorder = styled.div`
  background-color: white;
  padding: 2vh ;
  position: relative;
`;
ScratchBorder.displayName = 'ScratchBorder';

const ScratchBorderPattern = styled(borderScratchSVG)`
  position: absolute;
  height: 100%;
  top: 0;
`;

export const ScratchBorderPatternLeft = styled(ScratchBorderPattern)`
  transform: rotate(180deg);
  left: -2.3vw;
  `;
ScratchBorderPatternLeft.displayName = 'ScratchBorderPatternLeft';

export const ScratchBorderPatternRight = styled(ScratchBorderPattern)`
  right: -2.3vw;
`;
ScratchBorderPatternRight.displayName = 'ScratchBorderPatternRight';

export const ScratchBackground = styled.div<BackgroundProps>`
  background-color: ${(props): string => props.color};
  padding: 3vh 5.5vw;
  border: 1.5vw solid #313A49;
`;
ScratchBackground.displayName = 'ScratchBackground';

export const StarsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 104%;
  position: relative;
  left: -2%;
`;
StarsContainer.displayName = 'StarsContainer';

export const StarsContainerTop = styled(StarsContainer)`
  margin-bottom:3vh;
`;
StarsContainerTop.displayName = 'StarsContainerTop';

export const StarsContainerBottom = styled(StarsContainer)`
  margin-top:3vh;
`;
StarsContainerBottom.displayName = 'StarsContainerBottom';

export const StarImage = styled(starSVG)<StarsProps>`
  height: 4vh;
  fill: ${(props): string => props.color};
`;
StarImage.displayName = 'StarImage';

export const ScratchPatternImage = styled.img`
  width: 100%;
  display: block;
`;
ScratchPatternImage.displayName = 'ScratchPatternImage';

export const VideoContainer = styled.div`
  border-radius: 2vw; 
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  height: 26.5vh;
`;
VideoContainer.displayName = 'VideoContainer';

interface VideoElementProps {
  hasWon: boolean | null;
}
export const VideoElement = styled.video<VideoElementProps>`
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  display: none;
`;
VideoElement.displayName = 'VideoElement';

export const WinVideoElement = styled(VideoElement)`
  ${(props): string => {
    return props.hasWon === true
      ? 'display: block;'
      : '';
  }}
`;
WinVideoElement.displayName = 'WinVideoElement';

export const LoseVideoElement = styled(VideoElement)`
  ${(props): string => {
    return props.hasWon === false
      ? 'display: block;'
      : '';
  }}
`;
LoseVideoElement.displayName = 'LoseVideoElement';

export const PatternImage = styled.img`
  width: 100%;
`;
PatternImage.displayName = 'PatternImage';

export const LoadingText = styled.div`
  position: absolute;
  top: 25vh;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 3vh;
  color: black;
`;
LoadingText.displayName = 'LoadingText';

